import { ChevronRight, House } from 'lucide-react';
import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { construirMigas } from './navegacion/migas';
import { REGISTRO } from './navegacion/registro';

/**
 * Migas de pan: salen del registro de navegación. El espacio es solo texto, la
 * entrada y lo que cuelga de ella son enlaces, y la última es la pantalla actual.
 */
export function Breadcrumbs() {
  const { pathname, search } = useLocation();
  if (pathname.split('/').filter(Boolean).length === 0) return null;

  const migas = construirMigas(REGISTRO, { pathname, search });

  return (
    <nav aria-label="breadcrumb" className="flex items-center gap-1 text-body-lg">
      <Link
        to="/dashboard"
        className="text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors"
        aria-label="Inicio"
      >
        <House className="h-3.5 w-3.5" />
      </Link>
      {migas.map((miga, i) => {
        const esUltima = i === migas.length - 1;
        return (
          <Fragment key={`${i}-${miga.to ?? miga.label}`}>
            <ChevronRight className="text-muted-foreground h-3.5 w-3.5" />
            {esUltima ? (
              <span aria-current="page" className="text-foreground font-medium">
                {miga.label}
              </span>
            ) : miga.to ? (
              <Link to={miga.to} className="text-muted-foreground hover:text-foreground transition-colors">
                {miga.label}
              </Link>
            ) : (
              <span className="text-muted-foreground">{miga.label}</span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
